<template>
  <div>
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="用户名/手机号">
        <el-input v-model="searchForm.keyword" clearable></el-input>
      </el-form-item>
      <el-form-item label="原始单号">
        <el-input v-model="searchForm.originOrderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="退款单号">
        <el-input v-model="searchForm.refundOrderNo" clearable></el-input>
      </el-form-item>
      <el-form-item label="退款状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in refundStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="searchForm.beginCreateTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
        <span> ~ </span>
        <el-date-picker
          v-model="searchForm.endCreateTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="退款时间">
        <el-date-picker
          v-model="searchForm.beginRefundTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
        <span> ~ </span>
        <el-date-picker
          v-model="searchForm.endRefundTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="searchForm.auditStatus" clearable filterable>
          <el-option
            v-for="item in auditStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
    </el-form>

    <!--table-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
      id="tableId"
    >
      <el-table-column
        label="退款单号"
        prop="refundNo"
        align="center"
      ></el-table-column>
      <el-table-column label="原始单号" prop="originNo" align="center">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleOrderDetail(scope.row.originNo)"
            >{{ scope.row.originNo }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="退款者" prop="userName" align="center">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            type="primary"
            @click="handleSubscriber(scope.row)"
            >{{
              `${scope.row.subscriber.subscriberName || ""}/${scope.row
                .subscriber.subscriberPhone || ""}`
            }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="退款金额" prop="refundAmount" align="center">
      </el-table-column>
      <el-table-column
        label="退款原因"
        prop="reason"
        align="center"
      ></el-table-column>
      <el-table-column label="退款状态" prop="status" align="center">
        <template slot-scope="scope">
          {{ refundStatusMap[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column
        label="实际退款金额"
        prop="actualRefundAmount"
        align="center"
      >
      </el-table-column>
      <el-table-column label="退款流水号" prop="refundTradeNo" align="center">
      </el-table-column>
      <el-table-column label="到账账户" prop="refundAccount" align="center">
      </el-table-column>
      <el-table-column label="申请时间" prop="created" align="center">
      </el-table-column>
      <el-table-column label="退款时间" prop="refundTime" align="center">
      </el-table-column>
      <el-table-column label="审核状态" prop="auditStatus" align="center">
        <template slot-scope="scope">
          {{ auditStatusMap[scope.row.auditStatus] }}
        </template>
      </el-table-column>
      <el-table-column label="审核人" prop="auditor" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="handleAudit(scope.row)"
            v-if="scope.row.auditStatus == 1"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--dialog-->
    <el-dialog
      title="审核"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="dialogFormRef" :model="dialogForm" size="mini">
        <el-form-item label="退款单号">
          <el-input v-model="dialogForm.refundNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="dialogForm.refundAmount" disabled></el-input>
        </el-form-item>
        <el-form-item label="审核状态" prop="auditStatus">
          <el-select v-model="dialogForm.auditStatus" style="width: 100%;">
            <el-option
              v-for="item in auditStatusOptions2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核备注" prop="auditRemark">
          <el-input
            type="textarea"
            v-model="dialogForm.auditRemark"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAuditSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { loadRefundOrderPage, auditRefundOrder } from "@/api/giftCard";
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      refundStatusOptions: [
        // 退款状态 1. 审核中 2. 退款中 3. 退款成功 4. 退款失败 5. 退款关闭 6. 退款异常
        { label: "审核中", value: 1 },
        { label: "退款中", value: 2 },
        { label: "退款成功", value: 3 },
        { label: "退款失败", value: 4 },
        { label: "退款关闭", value: 5 },
        { label: "退款异常", value: 6 }
      ],
      refundStatusMap: {
        1: "审核中",
        2: "退款中",
        3: "退款成功",
        4: "退款失败",
        5: "退款关闭",
        6: "退款异常"
      },
      auditStatusOptions: [
        // 审核状态 1. 待审核 2. 审核通过 3. 审核不通过
        { label: "待审核", value: 1 },
        { label: "审核通过", value: 2 },
        { label: "审核不通过", value: 3 }
      ],
      auditStatusOptions2: [
        {
          label: "通过",
          value: 2
        },
        {
          label: "拒绝",
          value: 3
        }
      ],
      auditStatusMap: {
        1: "待审核",
        2: "审核通过",
        3: "审核不通过"
      },
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        auditStatus: 2,
        auditRemark: ""
      },
      dialogRules: {
        auditStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" }
        ]
      },
      dialogFormRef: null,
      dialogLoading: false,
      dialogTitle: "",
      dialogWidth: "30%"
    };
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    loadPage(pageNum) {
      this.loading = true;
      this.searchForm.pageNum = pageNum;
      loadRefundOrderPage(this.searchForm)
        .then(res => {
          this.loading = false;
          if (res.data.status == 100) {
            this.searchForm.total = res.data.results.total;
            this.tableData = res.data.results.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAudit(row) {
      this.dialogForm = {
        id: row.id,
        refundNo: row.refundNo,
        refundAmount: row.refundAmount,
        auditStatus: 2,
        auditRemark: ""
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogForm = {};
      this.dialogVisible = false;
    },
    handleAuditSubmit() {
      const { auditStatus, auditRemark } = this.dialogForm;
      if (auditStatus == 3 && !auditRemark) {
        this.$message.error("请填写审核备注");
        return;
      }
      this.$confirm("确定审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this._audit();
        })
        .catch(() => {});
    },
    _audit() {
      this.dialogLoading = true;
      auditRefundOrder(this.dialogForm)
        .then(res => {
          this.dialogLoading = false;
          if (res.data.status == 100) {
            this.$message.success("审核成功");
            this.dialogVisible = false;
            this.loadPage(1);
            this.dialogForm = {};
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// orderRefund.vue?f93013b6